/* eslint-disable max-len */

import React, { Component } from 'react';
import { arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import {
    display,
    position
} from '../../../commonStyles';
import styles from './styles';

import { returnDropdownLinkGroups } from './methods';

import {
    toggleHelpDropdown,
    toggleVenueDropdown,
    togglePerfDropdown,
    toggleInvoiceDropdown,
    toggleInventDropdown,
    toggleAdminHelpDropdown,
    toggleNavDropdown
} from '../../../modules/navigation';

import {
    getDomain,
    getLang,
    getNavigation
} from '../../../selectors';

import Translatable from '../../../components/Translatable';
import AvatarSection from './AvatarSection';
import Dropdown from './Dropdown';

class Nav extends Component {
    static propTypes = {
        domain: string.isRequired,
        navigation: shape({
            dropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            helpDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            venueDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            perfDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            invoiceDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            inventDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            adminHelpDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            linkGroups: arrayOf(shape({
                id: number,
                title: shape({
                    transKey: string
                }),
                links: arrayOf(shape({
                    id: number.isRequired,
                    icon: string,
                    title: shape({
                        transKey: string.isRequired,
                        count: number,
                        replacements: object
                    }).isRequired,
                    url: string,
                    shown: bool
                }))
            })),
            user: shape({
                id: oneOfType([number, string]),
                isAdmin: bool,
                isLoggedIn: bool,
                adminModeId: number
            })
        }).isRequired,
        toggleAdminHelpDropdown: func.isRequired,
        toggleHelpDropdown: func.isRequired,
        toggleInventDropdown: func.isRequired,
        toggleInvoiceDropdown: func.isRequired,
        toggleNavDropdown: func.isRequired,
        togglePerfDropdown: func.isRequired,
        toggleVenueDropdown: func.isRequired
    }

    constructor(props) {
        super(props);
        const { dropdown, helpDropdown, venueDropdown, perfDropdown, invoiceDropdown, inventDropdown, adminHelpDropdown, linkGroups } = this.props.navigation;
        if (dropdown) {
            this._dropdownLinkGroups = returnDropdownLinkGroups(dropdown, linkGroups);
        }
        if (helpDropdown) {
            this._helpDropdownLinkGroups = returnDropdownLinkGroups(helpDropdown, linkGroups);
        }
        if (venueDropdown) {
            this._venueDropdownLinkGroups = returnDropdownLinkGroups(venueDropdown, linkGroups);
        }
        if (perfDropdown) {
            this._perfDropdownLinkGroups = returnDropdownLinkGroups(perfDropdown, linkGroups);
        }
        if (invoiceDropdown) {
            this._invoiceDropdownLinkGroups = returnDropdownLinkGroups(invoiceDropdown, linkGroups);
        }
        if (inventDropdown) {
            this._inventDropdownLinkGroups = returnDropdownLinkGroups(inventDropdown, linkGroups);
        }
        if (adminHelpDropdown) {
            this._adminHelpDropdownLinkGroups = returnDropdownLinkGroups(adminHelpDropdown, linkGroups);
        }
    }

    _dropdownLinkGroups = []
    _helpDropdownLinkGroups = []
    _venueDropdownLinkGroups = []
    _perfDropdownLinkGroups = []
    _invoiceDropdownLinkGroups = []
    _inventDropdownLinkGroups = []
    _adminHelpDropdownLinkGroups = []

    handleToggleHelpDropdown = () => {
        if (!this.props.navigation.helpDropdown.isVisible) {
            this.props.toggleHelpDropdown();
        }
    }

    handleToggleVenueDropdown = () => {
        if (!this.props.navigation.venueDropdown.isVisible) {
            this.props.toggleVenueDropdown();
        }
    }

    handleTogglePerfDropdown = () => {
        if (!this.props.navigation.perfDropdown.isVisible) {
            this.props.togglePerfDropdown();
        }
    }

    handleToggleInvoiceDropdown = () => {
        if (!this.props.navigation.invoiceDropdown.isVisible) {
            this.props.toggleInvoiceDropdown();
        }
    }

    handleToggleInventDropdown = () => {
        if (!this.props.navigation.inventDropdown.isVisible) {
            this.props.toggleInventDropdown();
        }
    }

    handleToggleAdminHelpDropdown = () => {
        if (!this.props.navigation.adminHelpDropdown.isVisible) {
            this.props.toggleAdminHelpDropdown();
        }
    }

    render() {
        const { dropdown, helpDropdown, venueDropdown, perfDropdown, invoiceDropdown, inventDropdown, adminHelpDropdown, user } = this.props.navigation;
        return (
            <div className={css(styles.navContainer)}>
                <nav>
                    <ul className={css(styles.navList)}>
                        {
                            user.isSpoofMode || (user.isLoggedIn && user.isAdmin) ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable
                                            attributes={{ title:
                                                {
                                                    transKey: user.isSpoofMode ?
                                                        'nav.admin_unadopt' :
                                                        'nav.admin_adopt'
                                                }
                                            }}
                                        >
                                            <a
                                                href={
                                                    user.isSpoofMode ?
                                                        `/${
                                                            this.props.domain
                                                        }/administrator/spoof/disengage` :
                                                        `/${
                                                            this.props.domain
                                                        }/administrator/spoof/engage`
                                                }
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable
                                                            content={{
                                                                transKey: user.isSpoofMode ?
                                                                    'nav.admin_unadopt' :
                                                                    'nav.admin_adopt'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.bookings' } }}>
                                            <a
                                                href={
                                                    `/${
                                                        this.props.domain
                                                    }/administrator/reservations`
                                                }
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.bookings' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            href={
                                                `/${
                                                    this.props.domain
                                                }/administrator/enquiries`
                                            }
                                            className={css(styles.navLink)}
                                            title="Enquiries"
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Enquiries
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleTogglePerfDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Performance
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            perfDropdown && perfDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={perfDropdown}
                                                    dropdownLinkGroups={
                                                        this._perfDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.togglePerfDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleToggleInvoiceDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Payments
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            invoiceDropdown && invoiceDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={invoiceDropdown}
                                                    dropdownLinkGroups={
                                                        this._invoiceDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.toggleInvoiceDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleToggleInventDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Inventory
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            inventDropdown && inventDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={inventDropdown}
                                                    dropdownLinkGroups={
                                                        this._inventDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.toggleInventDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            href={
                                                `/${
                                                    this.props.domain
                                                }/administrator/users`
                                            }
                                            className={css(styles.navLink)}
                                            title="Users"
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Users
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isAdmin && !user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleToggleAdminHelpDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <span>
                                                        Helpers
                                                    </span>
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            adminHelpDropdown && adminHelpDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={adminHelpDropdown}
                                                    dropdownLinkGroups={
                                                        this._adminHelpDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.toggleAdminHelpDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> : null
                        }
                        {
                            (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.add_new_listing' } }}>
                                            <a
                                                href={`/${this.props.domain}/dashboard/listings`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.add_new_listing' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleToggleVenueDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <Translatable content={{ transKey: 'nav.venue' }} />
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            venueDropdown && venueDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={venueDropdown}
                                                    dropdownLinkGroups={
                                                        this._venueDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.toggleVenueDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> :
                                !user.isAdmin || user.isSpoofMode ?
                                    <li className={css(display.tableCell)}>
                                        <div className={css(position.relative)}>
                                            <Translatable attributes={{ title: { transKey: 'nav.list_your_space' } }}>
                                                <a
                                                    href={
                                                        !user.isLoggedIn ?
                                                            `/${this.props.domain}/list/overview` :
                                                            user.isVenueOwner ?
                                                                `/${
                                                                    this.props.domain
                                                                }/dashboard/listings` :
                                                                `/${
                                                                    this.props.domain
                                                                }/venues/new`
                                                    }
                                                    className={css(styles.navLink)}
                                                >
                                                    <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                        <div className={css(styles.underline)}>
                                                            <Translatable content={{ transKey: 'nav.list_your_space' }} />
                                                        </div>
                                                    </div>
                                                </a>
                                            </Translatable>
                                        </div>
                                    </li> : null
                        }
                        {
                            user.isLoggedIn &&
                            !user.isVenueOwner &&
                            (!user.isAdmin || user.isSpoofMode) ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.favourites' } }}>
                                            <a
                                                href={`/${this.props.domain}/dashboard/favourites`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.favourites' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            (!user.isAdmin || user.isSpoofMode) &&
                            user.isVenueOwner ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.schedule' } }}>
                                            <a
                                                href={`/${this.props.domain}/dashboard/schedule`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.schedule' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isLoggedIn && (!user.isAdmin || user.isSpoofMode) ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.bookings' } }}>
                                            <a
                                                href={
                                                    user.isVenueOwner ?
                                                        `/${
                                                            this.props.domain
                                                        }/dashboard/venue-bookings` :
                                                        `/${
                                                            this.props.domain
                                                        }/dashboard/bookings`
                                                }
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.bookings' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isLoggedIn && (!user.isAdmin || user.isSpoofMode) ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.inbox' } }}>
                                            <a
                                                href={`/${this.props.domain}/dashboard/inbox`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.inbox' }} />
                                                        <svg className={css(styles.notificationBadge)}>
                                                            <circle
                                                                cx="3"
                                                                cy="3"
                                                                r="3"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            (!user.isAdmin || user.isSpoofMode) &&
                            user.isVenueOwner ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'nav.widget' } }}>
                                            <a
                                                href={`/${this.props.domain}/dashboard/widget`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'nav.widget' }} />
                                                        {' '}
                                                        <Translatable content={{ transKey: 'nav.new' }}>
                                                            <span className={css(styles.newText)} />
                                                        </Translatable>
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            !user.isAdmin || user.isSpoofMode ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <a
                                            className={css(styles.navLink)}
                                            onClick={this.handleToggleHelpDropdown}
                                        >
                                            <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                <div className={css(styles.underline)}>
                                                    <Translatable content={{ transKey: 'common.help' }} />
                                                </div>
                                            </div>
                                        </a>
                                        {
                                            helpDropdown && helpDropdown.isVisible ?
                                                <Dropdown
                                                    dropdown={helpDropdown}
                                                    dropdownLinkGroups={
                                                        this._helpDropdownLinkGroups
                                                    }
                                                    clickOutsideActive
                                                    toggleNavDropdown={
                                                        this.props.toggleHelpDropdown
                                                    }
                                                /> : null
                                        }
                                    </div>
                                </li> : null
                        }
                        {
                            !user.isLoggedIn ?
                                <li className={css(display.tableCell)}>
                                    <div className={css(position.relative)}>
                                        <Translatable attributes={{ title: { transKey: 'common.sign_up' } }}>
                                            <a
                                                href={`/${this.props.domain}/users/signup`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'common.sign_up' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li> : null
                        }
                        {
                            user.isLoggedIn && dropdown ?
                                <li className={css(display.tableCell)}>
                                    <div
                                        className={css(position.relative)}
                                        style={{ marginRight: '8px' }}
                                    >
                                        <AvatarSection
                                            dropdown={dropdown}
                                            dropdownLinkGroups={this._dropdownLinkGroups}
                                            toggleNavDropdown={this.props.toggleNavDropdown}
                                            user={this.props.navigation.user}
                                        />
                                    </div>
                                </li> :
                                <li className={css(display.tableCell)}>
                                    <div
                                        className={css(position.relative)}
                                        style={{ marginRight: '8px' }}
                                    >
                                        <Translatable attributes={{ title: { transKey: 'common.login' } }}>
                                            <a
                                                href={`/${this.props.domain}/users/signin`}
                                                className={css(styles.navLink)}
                                            >
                                                <div className={css(styles.underlineWrapper, styles.itemInnerUnderlined)}>
                                                    <div className={css(styles.underline)}>
                                                        <Translatable content={{ transKey: 'common.login' }} />
                                                    </div>
                                                </div>
                                            </a>
                                        </Translatable>
                                    </div>
                                </li>
                        }
                    </ul>
                </nav>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    domain: getDomain(state),
    lang: getLang(state),
    navigation: getNavigation(state)
});

const mapDispatchToProps = dispatch => ({
    toggleHelpDropdown: () => dispatch(toggleHelpDropdown()),
    toggleVenueDropdown: () => dispatch(toggleVenueDropdown()),
    togglePerfDropdown: () => dispatch(togglePerfDropdown()),
    toggleInvoiceDropdown: () => dispatch(toggleInvoiceDropdown()),
    toggleInventDropdown: () => dispatch(toggleInventDropdown()),
    toggleAdminHelpDropdown: () => dispatch(toggleAdminHelpDropdown()),
    toggleNavDropdown: () => dispatch(toggleNavDropdown())
});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);



// WEBPACK FOOTER //
// ./src/components/Header/Nav/Nav.jsx